/* Built In Imports */
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, cursor, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButtonHyttV2 from '@components/Buttons/SimpleButtonHyttV2';
import { usePageType } from '@hooks/usePageType';
import { useMediaQuery } from 'react-responsive';


/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';
import { refineUrlDomain } from '@components/Utility/utils';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

let isFormVisible = false;
/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @param {pageName} pageName
 * @returns
 */
const ApplyStickyButton = ({ sectionContent, region, lang, pageName, pageData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');

  const MixpanelEvent = (btnText='') => {
    if(btnText){
        const Mixpanel = mixPanel(window?.location.pathname);
        Mixpanel.track("hytt_cta_click", {
          cta: "sticky cta",
          program_name: "Hatha Yoga Teacher Training",
          element: btnText,
        });
    }
  } 

  useEffect(() => {
    if (!router.isReady) return;
    setCurrentUrl(refineUrlDomain(sectionContent[0].linkUrl, region, lang));
  }, [router.isReady, sectionContent[0].linkUrl, isMobile, pageName]);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const topbanner = document.getElementById('top-banner');
    //const ieoPrgSectionDiv = document.getElementById('practice-curriculum');
    //const othertrainingDiv = document.getElementById('other-aspects-of-training');
    //const footerDiv = document.getElementById('footer');
    const heightToHideFrom = window.innerHeight * 0.4;

    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      const inViewPort = topbanner && isVisInViewport(topbanner);
      //const inofferViewPort = sneak && isVisInViewport(sneak);
      //const footerInViewPort = footerDiv && isVisInViewport(footerDiv);
      //const hyttPrgViewPort = ieoPrgSectionDiv && isVisInViewport(ieoPrgSectionDiv);
      //console.log('winScroll', winScroll, enrollSectionDiv, inViewPort);
      if (inViewPort) {
        setIsVisible(false);
      } else 
      if (!sectionContent[0]?.buttonText) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(false);
    }
  };
  // console.log('==> button ', sectionContent[0]?.buttonText ? true : false);
  if(isMobile){
    return (
    <Box
        position="fixed"
        //top={{ base: '86.8%', md: '30%' }}
        //top={{ base: 'unset', md: '30%' }}
        bottom={{ base: '0', md: 'unset' }}
        width={{ base: '100%', md: 'auto' }}
        zIndex="100"
        //left={{ base: '50%', md: 'unset' }}
        right={{ base: 'unset', md: '0px' }}
        //maxW={{ base: 'auto', md: '150px', lg: '180px' }}
        // transform={{
        //   base: 'translateX(-50%)',
        //   md: 'none',
        // }}
      >
          <Box
          display={'flex'}
          maxW={'100%'}
          onClick={() => MixpanelEvent(sectionContent[0]?.buttonText)}
         // minH={'88px'}
          backgroundColor={'#FFFAEF'}
          padding={{ base: '10px', sm: '12px', md: '14px', lg: '16px' }}
          boxShadow={'0px 0px 16px 10px #71645E14'}
          height={"88px"}
          >             
          <Link
          href={currentUrl}
          target="_blank"
          id="hytt-apply-sticky-btn"
          //width={'280px'}
          width={{ base: '90%', sm: '90%', md: '60%', lg: '50%' }}
          padding={{ base: '18px', sm: '20px', md: '14px', lg: '16px' }}
          height={"58px"}
          //height={'80px'}
          //height={'58px'}
          //padding={'18px'}
          style={sectionContent[0]}
          region={region}
          color = {'#262626'}
          lang={lang}
          background={'#FFAE27'}
          lineHeight="24px"
          //icon={isThemeActive && pageConfigVal?.btn?.icon}
          fontFamily={'FedraSansStd-book'}
          fontSize={'24px'}
          display="flex"
          borderRadius={'5px'}
          fontWeight={'600'}
          alignItems="flex-center"
          justifyContent="center"
          textAlign={'center'}
          cursor={'pointer'} 
          margin={'auto'}          
          _hover={{
            background:'#FFAE27',
            color:'#262626'
          }}
        >
           {sectionContent[0].buttonText}
        </Link>
        </Box>
      </Box>
    );
  }
  else if(isVisible)
  {
    return (
      <Box
        position="fixed"
        top={{ base: isMobile? '40%': 'unset', md: '30%' }}
        //top={{ base: 'unset', md: '30%' }}
        bottom={{ base: '0', md: 'unset' }}
        width={{ base: '100%', md: 'auto' }}
        zIndex="100"
        left={{ base: '50%', md: 'unset' }}
        right={{ base: 'unset', md: '0px' }}
        //maxW={{ base: 'auto', md: '150px', lg: '180px' }}
        transform={{
          base: 'translateX(-50%)',
          md: 'none',
        }}
      >
        {!isMobile && (
          <Link
          onClick={() => MixpanelEvent(sectionContent[0]?.buttonText)}
          href={currentUrl}
          target="_blank"
          id="hytt-apply-sticky-btn"
          width={{ base: '140px', md:'140px', lg:'140px' }}
          height={'91px'}
          padding={'15px'}
          mb="0"
          mt="0"
          style={sectionContent[0]}
          region={region}
          color = {'#262626'}
          lang={lang}
          background={'#FFAE27'} 
          boxShadow="0px 0.41px 2.2px 0px #73320C0C, 0px 1.79px 4.56px 0px #73320C13, 0px 4.4px 9.1px 0px #73320C18, 0px 8.47px 17.84px 0px #73320C1D,0px 14.26px 32.8px 0px #73320C25, 0px 22px 56px 0px #73320C30"
          lineHeight="29px"
          //icon={isThemeActive && pageConfigVal?.btn?.icon}
          fontFamily={'FedraSansStd-book'}
          fontSize={{
            base: '20px',
            md: '24px',
            lg: '24px',
          }}
          display="flex"
          borderTopLeftRadius={'5px'}
          borderBottomLeftRadius={'5px'}
          fontWeight={'600'}
          alignItems="flex-center"
          justifyContent="center"
          textAlign={'center'}
          cursor={'pointer'}           
          _hover={{
            background:'#FFAE27',
            color:'#262626'
          }}
        >
           {sectionContent[0].buttonText}
        </Link>
        )}
        </Box>
    );
  }
  
  
};

export default ApplyStickyButton;
